function handleIndexComponent(){
    const indexComponents = document.querySelectorAll('.index-component')

    indexComponents.forEach((indexComponent, index) => {
        if(indexComponent != null && indexComponents.length > 0){  
            indexComponent.setAttribute('data-index', index)
            
            // main-header reference
            const mainHeader = document.querySelector('.main-header')
        
            // Watch for any change in the main-header "style" attribute
            var headerObserver = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.type === "attributes") {
                        // Check if the main-header is fixed
                        if (mainHeader.getAttribute('style').includes('top: 0')) {
                            // Is fixed
                            indexComponent.classList.add('index-component--offset')
                        } else {
                            // Not fixed
                            indexComponent.classList.remove('index-component--offset')
                        }
                    }
                })
            })
            headerObserver.observe(mainHeader, {
                attributeFilter: ["style"]
            })
        
            // Change "index-component" to position "fixed" on mobile
            function checkIndexPosition() {
                const bounding = indexComponent.getBoundingClientRect()
        
                // Check if the component touched the page top
                if (bounding.top <= 0) {
                    indexComponent.classList.add('index-component--fixed')
                    document.documentElement.classList.add('spt-200')
                } else {
                    indexComponent.classList.remove('index-component--fixed')
                    document.documentElement.classList.remove('spt-200')
                }
            }
            window.addEventListener('scroll', checkIndexPosition)
        
            // index-component Accordion reference (mobile)
            const indexAccordion = new bootstrap.Collapse('#indexCollapse', {
                toggle: false
            })
         
            // Get all h2 from all article-text blocks
            const articleTextElements = document.querySelectorAll('.article-text')
            const articleHeadings = [] 
            articleTextElements.forEach((articleText) => {
                // Check if article-text is visible
                if(!articleText.classList.contains('d-none')){
                    const headings = articleText.querySelectorAll('h2')
                    headings.forEach(heading => {
                        articleHeadings.push(heading)
                    })
                }
            })
            
            // Get the all heading references and create the links
            const indexLinkList = indexComponent.querySelector('.index-component__link-list')
            
            // Clear indexList
            indexLinkList.innerHTML = ''

            articleHeadings.forEach((heading, index) => {
                // Create heading id
                const headingID = `${heading.innerHTML.replace(/\s/g, '')}-${index}`
                heading.setAttribute('id', headingID)
        
                // Create link and add href
                const li = document.createElement('li')
                li.innerHTML = `<a class="index-component__link" href='#${headingID}'>${heading.innerHTML}</a>`
                indexLinkList.appendChild(li)
        
                // Close the accordion when clicking in a link (mobile)
                li.querySelector('a').onclick = () => {
                    indexAccordion.hide()
                }
            })
        
            // Change index-component link style based on heading position
            updateLinkArrow()
        
            // Update on scroll
            window.addEventListener('scroll', () => {
                updateLinkArrow()
            })
        
            function updateLinkArrow(){
                articleHeadings.forEach((heading) => {
                    const headingID = heading.getAttribute('id')
                    const indexLink = indexLinkList.querySelector(`[href='#${headingID}']`)
                    if(indexLink != null){
                        // Check if the heading is bellow the link
                        if(compareScrollPosition(heading, indexLinkList, 140)){
                            indexLink.classList.add('index-component__link--down')
                        } else {
                            indexLink.classList.remove('index-component__link--down')
                        }
                    }
                })
        
                const indexLinks = indexLinkList.querySelectorAll('.index-component__link')
                const downLinks = indexLinkList.querySelectorAll('.index-component__link--down')
                const currentLinkIndex = indexLinks.length - downLinks.length
        
                // Style the active index link
                indexLinks.forEach((link, index) => {
                    if(currentLinkIndex == index){
                        link.classList.add('index-component__link--current')
                    } else {
                        link.classList.remove('index-component__link--current')
                    }
                })
            }
        
            function compareScrollPosition(elementA, elementB, offset) {
                var rectA = elementA.getBoundingClientRect();
                var rectB = elementB.getBoundingClientRect();
        
                return (rectA.y + offset) > rectB.y;
            }
        }
    })
}

document.addEventListener("DOMContentLoaded", function(){
    handleIndexComponent()
})